module.exports = __webpack_public_path__ + "static/media/white-apple.d47fc728.svg";